import { ReactNode } from 'react';
import classNames from 'classnames';
import ShadowScroll from '../ShadowScroll';

export interface BodyProps {
  children: ReactNode;
  className?: string;
}

export default function Body({ children, className }: BodyProps) {
  return (
    <ShadowScroll
      className={classNames(
        'flex overflow-hidden border border-gray-100',
        className
      )}>
      <ShadowScroll.ScrollArea className="flex flex-col flex-1 p-4 overflow-auto">
        {children}
      </ShadowScroll.ScrollArea>
    </ShadowScroll>
  );
}
